import { useQuery } from '@tanstack/react-query';

import { ApiMomentOverviewFragment } from 'gql/api/api-fragments.generated';
import * as Generated from 'gql/api/queries/moment-by-nft.generated';

export async function getMomentByNft(
  variables: Generated.ApiMomentByNftVariables
): Promise<ApiMomentOverviewFragment | null> {
  const fetchMomentByNft = Generated.useMomentByNft.fetcher(variables);
  const data = await fetchMomentByNft();
  return data.moment;
}

export function useMomentByNft(variables: Generated.ApiMomentByNftVariables) {
  return useQuery({
    queryKey: ['moment', 'nft', variables],
    queryFn: () => getMomentByNft(variables),
  });
}
